import type { FaireProductEntity } from "../../entity_types/product";

export const atc_goes_well_1: FaireProductEntity = {
  token: "atc_goes_well_1",
  type: "product",
  name: "Leather Card Case - Red",
  brandName: "Lumi",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/33b335a80b5ca9d4d0a340c3dc4489d8e64b973a64cf105072b9e985935f1af2.jpeg",
  priceDollars: 18,
  msrpDollars: 36,
  description: "Recommended accessory for ATC flow.",
  tags: ["goes-well-with", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
